module.exports = __webpack_public_path__ + "img/joyfulmovement-logo.9c432867.svg";